export enum ProcedureStatus {
  DRAFT = 'B',
  PUBLISHED = 'P',
  ENVELOPE_A_OPENED = 'ASA',
  ENVELOPE_B_OPENED = 'ASB',
  CELEBRATED = 'C',
  FINISHED = 'F'
}
